export default function generateBreadcrumbs(breadcrumbs) {
    const baseURL = `https://www.celerity-uk.com`
    return {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
            ...breadcrumbs.map((item,index)=>{
                return {
                    "@type": "ListItem",
                    position: index+1,
                    name: item.text,
                    item: `${baseURL}${item.url}`
                }
            }),
        ]
      }
}
